var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "currentColor",
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.2 1h-1.55v8.5H1.378V25h23.96l.04-15.5H14.2V1Zm-1.55 10.074v6.208l-2.76-2.72-1.072 1.157 4.633 4.564 4.488-4.571-1.086-1.143L14.2 17.27v-6.196h9.664l-.033 12.359H2.9V11.074h9.75Zm.781 6.978-.296-.292h.583l-.287.292Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DownloadFilled.7da7890b719ffbd88dade7155c913786.svg";